/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClubsControllerListClubsV1200,
  ClubsControllerListClubsV1Params
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getClubsControllerListClubsV1Url = (params?: ClubsControllerListClubsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/clubs?${stringifiedParams}` : `/v1/clubs`
}

/**
 * Feeds the club picker when adding a club. Every agency sees every club; each row carries `addedByAgency` so clubs the agency already holds can be disabled.
 * @summary Search the global club catalog (paginated, searchable, orderable)
 */
export const clubsControllerListClubsV1 = async (params?: ClubsControllerListClubsV1Params, options?: RequestInit): Promise<ClubsControllerListClubsV1200> => {

  return apiRequest<ClubsControllerListClubsV1200>(getClubsControllerListClubsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getClubsControllerListClubsV1QueryKey = (params?: ClubsControllerListClubsV1Params,) => {
    return [
    `/v1/clubs`, ...(params ? [params] : [])
    ] as const;
    }


export const getClubsControllerListClubsV1QueryOptions = <TData = Awaited<ReturnType<typeof clubsControllerListClubsV1>>, TError = unknown>(params?: ClubsControllerListClubsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clubsControllerListClubsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClubsControllerListClubsV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clubsControllerListClubsV1>>> = ({ signal }) => clubsControllerListClubsV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clubsControllerListClubsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClubsControllerListClubsV1QueryResult = NonNullable<Awaited<ReturnType<typeof clubsControllerListClubsV1>>>
export type ClubsControllerListClubsV1QueryError = unknown


export function useClubsControllerListClubsV1<TData = Awaited<ReturnType<typeof clubsControllerListClubsV1>>, TError = unknown>(
 params: undefined |  ClubsControllerListClubsV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clubsControllerListClubsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clubsControllerListClubsV1>>,
          TError,
          Awaited<ReturnType<typeof clubsControllerListClubsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClubsControllerListClubsV1<TData = Awaited<ReturnType<typeof clubsControllerListClubsV1>>, TError = unknown>(
 params?: ClubsControllerListClubsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clubsControllerListClubsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clubsControllerListClubsV1>>,
          TError,
          Awaited<ReturnType<typeof clubsControllerListClubsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClubsControllerListClubsV1<TData = Awaited<ReturnType<typeof clubsControllerListClubsV1>>, TError = unknown>(
 params?: ClubsControllerListClubsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clubsControllerListClubsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search the global club catalog (paginated, searchable, orderable)
 */

export function useClubsControllerListClubsV1<TData = Awaited<ReturnType<typeof clubsControllerListClubsV1>>, TError = unknown>(
 params?: ClubsControllerListClubsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clubsControllerListClubsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClubsControllerListClubsV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






